import { render, staticRenderFns } from "./ExportCoursesLecturesModal.vue?vue&type=template&id=1567b5f3"
import script from "./ExportCoursesLecturesModal.vue?vue&type=script&lang=ts"
export * from "./ExportCoursesLecturesModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports